import React from 'react';
import style from './style.scss';
import {
  ProductForm
} from 'components/my-business/manage-product';
import {BusinessLayout} from 'components/layouts/business';
import BusinessZone from 'pages/my-business/BusinessZone.jsx';
import {Products} from 'base/api';
import {toastr} from 'react-redux-toastr';
import {withRouter} from 'react-router-dom';

class MyBusinessAddProduct extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {

    }
  }

  cb(response) {
    toastr.removeByType("success");
    toastr.success('Thành công!', 'Sản phẩm đã được thêm thành công. Thông tin sản phẩm cần được kiểm duyệt trước khi được đưa lên sàn. Bạn vui lòng đợi trong giây lát.');
    //
    this.props.history.push('/my-business/products');
  }

  render() {
    return (
      <BusinessLayout active='manage-product'>
        <ProductForm fnSubmit={Products.actions.add} cb={this.cb.bind(this)}/>
      </BusinessLayout>
    );
  }
}

export default BusinessZone(withRouter(MyBusinessAddProduct));



// WEBPACK FOOTER //
// ./components/my-business/MyBusinessAddProduct.jsx